// 专家答 专家端
export default {
  getQuestionList: '/newapi/router/expert-qa-question/getQuestionsForExpert',                      // 专家答专家端问题列表
  // getQuestionList: '//mock.mtmm.com/mock/165/newapi/router/hh-qa-question/getQuestionsForExpert', // 专家答专家端问题列表
  expertJobSetting: '/newapi/router/expert-jobSetting/expertJobSetting',                          // 专家服务设置
  updateExpertModify: '/newapi/router/expert-weiixin/expertModify',                                // 专家服务信息修改
  qusetionDialog: '/newapi/router/question/dialog/findDialogMsgPage',                              // 已完成订单查询IM历史消息
  questionInfo: '/newapi/router/question/dialog/findBusinessQuestionInfo',                         // 进入IM聊天时，获取聊天室相关信息
  bindDialog: '/newapi/router/question/dialog/saveBusinessPreMsg',                                 // 预发送消息校验接口
  saveQuestionStatus: '/newapi/router/question/order/saveQuestionStatus',                           // 取消，接单，拒单，完成
  expertInfo: '/newapi/router/health-experth5/queryExpertInfo',                                     // 专家个人中心专家信息
  settleInfo: '/newapi/router/health-experth5/settleInfo',                                          // 专家个人中心专家结算信息
  yearParam: '/newapi/router/health-experth5/getSettleYearParam',                                   // 结算年份获取
  settleList: '/newapi/router/health-experth5/settleList',                                          // 专家结算单列表
  orderDetail: '/newapi/router/health-experth5/fetchSettleBillOrderDetail'                          // 专家结算单获取明细
};



// WEBPACK FOOTER //
// ./src/comm/api/expertAnswer/index.js